// extracted by mini-css-extract-plugin
export default {"toolbar":"draft-toolbar_toolbar__p+BQf"};